import * as actionTypes from "Redux/Actions/actionTypes";

const doApplicationSearch = (searchCriteria, callback = () => {}) => ({
  type: actionTypes.APPLICATION_SEARCH,
  data: searchCriteria,
  callback,
});

export { doApplicationSearch };
